import React from 'react'
import Section from '../Section'
import Markdown from 'features/Markdown'
import { ContactForm } from 'features/Contact/ContactForm'

export default props => (
  <Section
    color={props.color}
    fullHeight={props.fullHeight}
    paddingTop={props.paddingTop}
    paddingBottom={0}
    sectionWidth={props.sectionWidth}
    style={props.centerText ? { textAlign: 'center' } : {}}
    pattern={props.pattern}
  >
    <Markdown text={props.text} color={props.color} />
    <ContactForm type={props.type || 'get-demo'} />
  </Section>
)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/ContactForm/ContactForm.jsx